import qs from '@halobear/utils/qs'
import { isMyApp } from '@/utils/bridge'

export const isDev = (isMyApp && qs.get('debug')) || process.env.NODE_ENV !== 'production'

// const isDev = false

const PROXY_DEV = 'https://app-renren-dev.weddingee.com'
const PROXY_PROD = 'https://app.renrenyan.com'

// const PROXY_TRAVEL_DEV = ""
const PROXY_TRAVEL_DEV = 'https://app-licheng-dev.weddingee.com'
const PROXY_TRAVEL_PROD = 'https://app-licheng.lichenglove.com'

// 接口默认域名
export const PROXY = isDev ? PROXY_DEV : PROXY_PROD
export const PROXY_TRAVEL = isDev ? PROXY_TRAVEL_DEV : PROXY_TRAVEL_PROD
